import GenericGauge from "./GenericGauge";

export default function OverviewGauge({
  value,
  invertColorScale = false,
  tooltipText = "",
}) {
  const settings = {
    r: 35,
    x0: 63,
    y0: 2,
    width: 130,
    height: 130,
    imgDimension: 105,
    boxWidth: "65px",
    boxHeight: "58px",
  };
  const percentage = invertColorScale ? 100 - value : value;
  return (
    <GenericGauge
      settings={settings}
      value={percentage}
      tooltipText={
        tooltipText
          ? tooltipText
          : invertColorScale
          ? "At risk entities out of total"
          : "Protected entities out of total"
      }
      invertColorScale={invertColorScale}
    />
  );
}
